"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonDefaultProps = {
    helpText: '',
    label: '',
};



//////////////////
// WEBPACK FOOTER
// ./src/demo/examples/FormExample/utils/component-commons.ts
// module id = 467
// module chunks = 0